import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../../../utils/formatters.js';

const StatsCards = ({ stats }) => {
    const { t } = useTranslation(['inventory']);

    return (
        <div className="stats-grid">
            <div className="stat-card">
                <h3>{stats.totalProducts}</h3>
                <p>{t('inventory:totalProducts')}</p>
            </div>
            <div className="stat-card">
                <h3>{stats.activeProducts}</h3>
                <p>{t('inventory:activeProducts')}</p>
            </div>
            <div className="stat-card">
                <h3>{stats.lowStockProducts}</h3>
                <p>{t('inventory:lowStock')}</p>
            </div>
            <div className="stat-card">
                <h3>{formatCurrency(stats.totalInventoryValue || 0)}</h3>
                <p>{t('inventory:totalValue')}</p>
            </div>
        </div>
    );
};

export default StatsCards;